
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Card',
  props: {
    titulo: {
      type: String,
    },
    classTitulo: {
      type: String,
      default: 'ui-card-info-titulo',
    },
    classBorda: {
      type: String,
      default: 'ui-card-info',
    },
    moverCardTitulo: {
      type: Boolean,
      default: false,
    },
    altura: {
      type: Number,
    },
  },
  setup(props) {
    return {
      props,
    };
  },
});
